import { render, staticRenderFns } from "./OrderDetailDrawer.vue?vue&type=template&id=089affc1&scoped=true"
import script from "./OrderDetailDrawer.vue?vue&type=script&lang=js"
export * from "./OrderDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailDrawer.vue?vue&type=style&index=0&id=089affc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089affc1",
  null
  
)

export default component.exports